<template>
  <div>
    <modal modal-id="edit-item">
      <div slot="title">{{ item.name ? 'Edit' : 'Add' }} Item</div>
      <div slot="form">
        <div class="row m-b-sm">
          <label for="">Item</label>
          <input type="text" class="form-control" v-model="item['name']">
        </div>
        <div class="row m-b-sm">
          <label for="">Description</label>
          <textarea class="form-control" v-model="item['description']" rows="3"></textarea>
        </div>
        <div class="row m-b-sm">
          <label for="">Quantity</label>
          <input type="number" class="form-control" v-model.number="item['quantity']">
        </div>
        <div class="row m-b-sm">
          <label for="">Price</label>
          <input type="number" class="form-control" v-model.number="item['price']">
        </div>
        <div class="row m-b-sm">
          <button class="btn btn-primary btn-xs" @click="saveItem">Save</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '../../../../../Helpers/Modal/Form'
import axios from 'axios'
import { eventBus } from '../../../../../../main'
export default {
  data () {
    return {
      editItem: {}
    }
  },
  components: {
    Modal
  },
  mounted () {},
  watch: {
    item: (i) => {
      this.editItem = {}
      this.editItem = {...i}
    }
  },
  props: ['statement', 'item'],
  methods: {
    saveItem () {
      let req
      console.log(this.item)
      if (this.item.index !== 'undefined') {
        req = axios.patch(`/billing/statement/${this.statement.id}/item/${this.item.index}`, this.item)
      } else {
        req = axios.post(`/billing/statement/${this.statement.id}/item`, this.item)
      }
      req.then(r => {
        eventBus.$emit('reloadStatements')
        eventBus.$emit('loadStatement', this.statement.id)
        $('#edit-item').modal('hide')
        this.editItem = {}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Statements/ItemModal.vue